import Vue from 'vue';
import Router from 'vue-router';
import Swal from 'sweetalert2';
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import Typography from "@/pages/Typography.vue";
import Icons from "@/pages/Icons.vue";
import Notifications from "@/pages/Notifications.vue";
import ManageRecords from "@/pages/ManageRecords";
import Login from "@/components/Login.vue";
import Unauthorized from "@/pages/Unauthorized.vue";
import Simulacion from "@/pages/Qr.vue";

Vue.use(Router);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Inicio",
        component: Dashboard,
        meta: { roles: ["admin", "usuario"] }
      },
      {
        path: "user",
        name: "Perfil Usuario",
        component: UserProfile,
        meta: { roles: ["admin"] }
      },
      {
        path: "table",
        name: "Crear",
        component: TableList,
        meta: { roles: ["admin", "usuario"] }
      },
      {
        path: "typography",
        name: "Mostrar",
        component: Typography,
        meta: { roles: ["admin", "usuario"] }
      },
      {
        path: "icons",
        name: "Administrar Usuarios",
        component: Icons,
        meta: { roles: ["admin"] }
      },
      {
        path: "manage",
        name: "Administrar Registros",
        component: ManageRecords,
        meta: { roles: ["admin"] }
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
        meta: { roles: ["admin", "usuario"] }
      },
      {
        path: "unauthorized",
        name: "Unauthorized",
        component: Unauthorized,
      },
      {
        path: "prueba",
        name: "prueba",
        component: Simulacion,
      },
    ],
  },
  {
    path: "/Login",
    redirect: { name: "Login" },
  },
];

const router = new Router({
  mode: "history",
  routes,
});

// Función para saber si el token está vencido
function isTokenExpired() {
  const expiry = localStorage.getItem("tokenExpiry");
  if (!expiry) return true;
  return Date.now() > parseInt(expiry);
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("authToken");
  let usuario = null;

  try {
    usuario = JSON.parse(localStorage.getItem("usuario"));
  } catch (e) {
    usuario = null;
  }

  const isAuthRoute = to.matched.some(record => record.meta.requiresAuth);
  const isLoginRoute = to.name === 'Login';

  const expiry = parseInt(localStorage.getItem("tokenExpiry"));
  const isExpired = !expiry || isNaN(expiry) || Date.now() > expiry;

  if (isExpired) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("tokenExpiry");

    // ⚠️ Si ya estás en login, no mostrar alerta ni redirigir
    if (isLoginRoute) {
      return next();
    }

  }


  if (isAuthRoute) {
    // Si no hay token o usuario (y no ha expirado aún, lo que es raro pero posible si se borran manualmente)
    if (!token || !usuario) {
      return next({ name: "Login" });
    }

    const allowedRoles = to.meta.roles;
    // Si la ruta tiene roles definidos y el usuario no tiene uno de los roles permitidos
    if (allowedRoles && !allowedRoles.includes(usuario.rol)) {
      return next({ path: "/unauthorized" });
    }

    // Si tiene token, usuario y roles correctos, o no hay roles definidos para la ruta
    return next();

  } else if (isLoginRoute && token && !isExpired) {
    // Si la ruta es el login Y el usuario ya tiene un token VÁLIDO,
    // redirige a la página principal (dashboard) para evitar que se quede en login.
    return next({ name: "Inicio" });
  }

  // Para todas las demás rutas no protegidas o públicas
  return next();
});



export default router;
